import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Footer, FloatingWa } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Portrete from "@/pages/Portrete";

const ScrollReset = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="site font-body bg-[#0B0B0C] text-[#F3EEE4]">
        <ScrollReset />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portrete" element={<Portrete />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <FloatingWa />
      </div>
    </BrowserRouter>
  );
}

export default App;
